import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Sutter Health Plan",
  shortName: "Sutter Health Plan",
  slug: "sutter-health-plan-insurance",
  seoTitle: "Sutter Health Plan TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Sutter Health Plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Sutter Health Plan in Coral Springs, FL.",
  seoKeywords:
    "Sutter Health Plan TMS coverage, Sutter Health TMS therapy, Sutter Health Plan depression treatment Florida, Sutter Health mental health benefits Coral Springs FL, Sutter Health Plan SAINT TMS",
  planType: "regional health maintenance organization (HMO) plan",
  planRegion: "Northern California",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services",
  planSpecificIntro:
    "Sutter Health Plan is a regional HMO serving members across Northern California, affiliated with the Sutter Health network. Sutter Health Plan typically includes behavioral health benefits that may cover TMS therapy when medical necessity criteria are met. As an HMO, coverage generally requires care to be received from in-network providers, and referrals may be needed for specialty services. Coverage for TMS, accelerated TMS protocols, and other advanced depression treatments depends on your specific plan, network arrangements, and documented medical necessity.",
  officialResourceUrl: "https://www.sutterhealth.org/health-plan",
  officialResourceLabel: "Sutter Health Plan official website",
};

export const SutterHealthPlanInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default SutterHealthPlanInsurance;
